<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
    [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<div style="height: 100vh; overflow: auto;">

    <div class="header" style="display: flex;
    align-items: center;
    justify-content: space-between;">
        <div>
            <img src="../../../assets/img/foodbud.png" alt="" style="width: 160px;">
        </div>

        <div class="dropdown-link-wrap">
            <img src="../../../assets/img/logout-circle-svgrepo-com.svg" alt="" style="    width: 30px;
    cursor: pointer;" title="Logout" (click)="logout()" >
        </div>
    </div>

    <div class="page-container">

        <!-- Top Section -->
        <div class="info-card">
            <h2 class="section-title">Restaurant Info</h2>
            <div class="info-row">
                <span class="label">Name:</span>
                <span class="value">{{ restaurant.name }}</span>
            </div>
            <div class="info-row">
                <span class="label">Email:</span>
                <span class="value">{{ restaurant.email }}</span>
            </div>
            <div class="info-row">
                <span class="label">Phone:</span>
                <span class="value">{{ restaurant.phone }}</span>
            </div>
        </div>

        <!-- Table Section -->
        <div class="table-card">
            <h3 class="section-title">Assigned Restaurants</h3>
            <table class="restaurant-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Unique ID</th>
                        <th>Email</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let r of assignedRestaurants">
                        <td>{{ r.name }}</td>
                        <td>{{ r.uniqueID }}</td>
                        <td>{{ r.email }}</td>
                        <td><button (click)="navigateTo(r.id)">Dashboard</button></td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>



</div>